export const DEFAULT_HEIGHT = 450;
